import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/destructuring-assignment */

/* eslint-disable react/prop-types */
import classNames from '@jd/jmtd-tools/es/classnames';
import React, { Fragment } from 'react';
import FormContext from '../tools/FormContext';
import Button from '../Button';
import ButtonGroup from '../ButtonGroup';
import CheckboxControl from '../CheckboxControl';
import Drag from '../Drag';
import ConfigConsumer from '../ConfigConsumer';
import Form from '../Form';
import FormItem from '../FormItem';
import { trackEvent } from '../tools/eventTracking';
import { flat } from '../tools/groupData';
import { getLocale } from '../locale';
import Icon from '../Icon';
import Empty from '../Empty';
import Popover from '../Popover';
import Input from '../Input';
import Collapse from '../Collapse';
export default function BasicCheckboxGroup(_ref, _ref2) {
  var data = _ref.data,
      isChecked = _ref.isChecked,
      value = _ref.value,
      withLabel = _ref.withLabel,
      withMore = _ref.withMore,
      update = _ref.update,
      locale = _ref.locale;
  var id = _ref2.id,
      size = _ref2.size,
      className = _ref2.className,
      alignControlWidth = _ref2.alignControlWidth,
      bordered = _ref2.bordered,
      resetValue = _ref2.resetValue,
      showLength = _ref2.showLength,
      minLength = _ref2.minLength,
      maxLength = _ref2.maxLength,
      showReset = _ref2.showReset,
      showClear = _ref2.showClear,
      showAll = _ref2.showAll,
      showSave = _ref2.showSave,
      onSave = _ref2.onSave,
      showSearch = _ref2.showSearch,
      searchValue = _ref2.searchValue,
      searchPlaceholder = _ref2.searchPlaceholder,
      onSearch = _ref2.onSearch,
      searchRender = _ref2.searchRender,
      separator = _ref2.separator,
      _ref2$formProps = _ref2.formProps,
      formProps = _ref2$formProps === void 0 ? {} : _ref2$formProps,
      keepOrder = _ref2.keepOrder,
      draggable = _ref2.draggable,
      onDragChange = _ref2.onDragChange,
      _ref2$onCollapse = _ref2.onCollapse,
      onCollapse = _ref2$onCollapse === void 0 ? function (x) {
    return x;
  } : _ref2$onCollapse,
      _ref2$onReset = _ref2.onReset,
      onReset = _ref2$onReset === void 0 ? function (x) {
    return x;
  } : _ref2$onReset,
      _ref2$onClear = _ref2.onClear,
      onClear = _ref2$onClear === void 0 ? function (x) {
    return x;
  } : _ref2$onClear,
      _ref2$trackComponentN = _ref2.trackComponentName,
      trackComponentName = _ref2$trackComponentN === void 0 ? 'CheckboxGroup' : _ref2$trackComponentN,
      _ref2$dataComponent = _ref2['data-component-name'],
      componentName = _ref2$dataComponent === void 0 ? 'CheckboxGroup' : _ref2$dataComponent;

  if (!data) {
    return null;
  }

  var currentCheckedLength = value.length; // 当前选中的数量

  var inMax = maxLength && currentCheckedLength === maxLength; // 处于最大可选状态

  var inMin = minLength && currentCheckedLength === minLength; // 处于全选状态

  function List(list) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        listLabel = _ref3.label,
        _ref3$serial = _ref3.serial,
        serial = _ref3$serial === void 0 ? 0 : _ref3$serial,
        _ref3$showMore = _ref3.showMore,
        showMore = _ref3$showMore === void 0 ? false : _ref3$showMore,
        _ref3$autoCollapse = _ref3.autoCollapse,
        autoCollapse = _ref3$autoCollapse === void 0 ? false : _ref3$autoCollapse;

    var labelNode;
    var timestamp = Date.now() + serial;
    var moreData = list.filter(function (_ref4) {
      var more = _ref4.more;
      return more;
    });

    if (withLabel && showAll && !searchValue && !withMore) {
      var length = list.length;
      var valueList = list.map(function (item) {
        return item.value;
      }); // value数组

      var checkedList = valueList.filter(isChecked); // 选中的value组成的列表

      var checkedLength = checkedList.length; // 选中的数量

      var allChecked = checkedLength === list.length; // 全部选中

      var empty = checkedLength === 0; // 没有选中

      var disabled = false;
      var toCheckedLength = length - checkedLength;
      var valueLength = value.length; // 如果有最大值或者最小值，计算禁用状态

      if (maxLength && !allChecked && toCheckedLength > maxLength - valueLength) {
        disabled = true;
      } else if (minLength && allChecked && currentCheckedLength - checkedLength < minLength) {
        disabled = true;
      }

      labelNode = /*#__PURE__*/React.createElement(CheckboxControl, {
        onChange: function onChange(nextChecked) {
          if (nextChecked) {
            update(value.concat(valueList.filter(function (v) {
              return !isChecked(v);
            })));
          } else {
            var checkedSet = new Set(checkedList);
            update(value.filter(function (v) {
              return !checkedSet.has(v);
            }));
          }
        },
        disabled: disabled,
        checked: allChecked,
        indeterminate: !allChecked && !empty
      }, listLabel);
    } else {
      labelNode = withMore ? /*#__PURE__*/React.createElement("div", {
        className: "jmtd-checkbox-group-more-label"
      }, /*#__PURE__*/React.createElement(Button, {
        startIcon: /*#__PURE__*/React.createElement(Icon, {
          className: !autoCollapse && !moreData.length ? '' : showMore ? 'jmti-caret-up' : 'jmti-caret-right'
        }),
        onClick: function onClick() {
          return onCollapse(serial, data);
        },
        link: true
      }), listLabel) : listLabel;
    }

    var getList = function getList(data) {
      return data.map(function (_ref5, index) {
        var label = _ref5.label,
            itemValue = _ref5.value,
            disabled = _ref5.disabled;
        var checked = isChecked(itemValue);
        return /*#__PURE__*/React.createElement(Drag, {
          key: itemValue,
          className: "jmtd-checkbox-item-drag-".concat(timestamp),
          serial: index,
          onChange: function onChange(_ref6) {
            var from = _ref6.from,
                to = _ref6.to;
            return onDragChange('checkbox-item', {
              withLabel: withLabel,
              data: data,
              serial: serial,
              listLabel: listLabel,
              from: from,
              to: to
            });
          },
          disabled: !draggable
        }, /*#__PURE__*/React.createElement(CheckboxControl, {
          className: "jmtd-checkbox-group-item",
          uncheckable: disabled,
          disabled: checked && inMin || !checked && inMax,
          key: itemValue,
          checked: checked,
          draggable: draggable,
          onChange: function onChange() {
            if (checked) {
              update(value.filter(function (v) {
                return v !== itemValue;
              }));
            } else if (keepOrder) {
              var set = new Set(value.concat(itemValue));
              update(flat(data).filter(function (i) {
                return set.has(i.value);
              }).map(function (i) {
                return i.value;
              }));
            } else {
              update(value.concat(itemValue));
            }
          }
        }, label));
      });
    };

    return /*#__PURE__*/React.createElement(FormItem, {
      className: !showMore && autoCollapse ? 'jmtd-checkbox-group-item-auto-collapsed' : '',
      label: labelNode
    }, getList(list), !autoCollapse && /*#__PURE__*/React.createElement(Collapse, {
      open: showMore
    }, getList(moreData)));
  }

  var timestamp = Date.now();
  var inner = data.length ? withLabel ? data.map(function (_ref7, serial) {
    var optionsData = _ref7.data,
        others = _objectWithoutProperties(_ref7, _excluded);

    return /*#__PURE__*/React.createElement(Drag, {
      key: serial,
      className: "jmtd-checkbox-group-item-drag-".concat(timestamp),
      serial: serial,
      onChange: function onChange(_ref8) {
        var from = _ref8.from,
            to = _ref8.to;
        return onDragChange('group-item', {
          data: data,
          from: from,
          to: to
        });
      },
      disabled: !draggable
    }, /*#__PURE__*/React.createElement(Fragment, {
      key: serial
    }, List(optionsData, _objectSpread({
      serial: serial
    }, others))));
  }) : List(data) : /*#__PURE__*/React.createElement(Empty, null);
  var buttons = [];

  if (showLength || maxLength) {
    buttons.push( /*#__PURE__*/React.createElement(Button, {
      key: "length",
      unclickable: true,
      link: true
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames('jmtd-checkbox-group-length', {
        'jmtd-checkbox-group-length-in-max': inMax
      })
    }, value.length), maxLength ? "/".concat(maxLength) : '', getLocale(locale).common.selected));
  }

  if (showSearch && !searchRender) {
    var popover = /*#__PURE__*/React.createElement("div", {
      className: "jmtd-checkbox-group-search-input"
    }, /*#__PURE__*/React.createElement(Input, {
      value: searchValue,
      onChange: onSearch,
      placeholder: searchPlaceholder,
      startIcon: /*#__PURE__*/React.createElement(Icon, {
        className: "jmt-search"
      })
    }));
    buttons.push( /*#__PURE__*/React.createElement(Popover, {
      key: "search",
      trigger: "click",
      showArrow: false,
      popover: popover
    }, /*#__PURE__*/React.createElement(Button, {
      link: true,
      "data-event-name": "search",
      startIcon: /*#__PURE__*/React.createElement(Icon, {
        className: "jmti-search"
      }),
      onClick: function onClick() {
        trackEvent({
          componentName: trackComponentName,
          eventName: 'search'
        });
      }
    })));
  }

  if (showSave) {
    buttons.push( /*#__PURE__*/React.createElement(Button, {
      key: "save",
      link: true,
      "data-event-name": "save",
      onClick: function onClick() {
        onSave(value);
        trackEvent({
          componentName: trackComponentName,
          eventName: 'save'
        });
      }
    }, "\u4FDD\u5B58"));
  }

  if (!maxLength && showAll) {
    buttons.push( /*#__PURE__*/React.createElement(Button, {
      key: "all",
      link: true,
      "data-event-name": "all",
      onClick: function onClick() {
        update(flat(data).map(function (item) {
          return item.value;
        }));
        trackEvent({
          componentName: trackComponentName,
          eventName: 'check all'
        });
      }
    }, getLocale(locale).common.all));
  }

  if (showReset) {
    buttons.push( /*#__PURE__*/React.createElement(Button, {
      key: "reset",
      link: true,
      "data-event-name": "reset",
      onClick: function onClick() {
        update(resetValue);
        onReset(resetValue);
        trackEvent({
          componentName: trackComponentName,
          eventName: 'reset'
        });
      }
    }, getLocale(locale).common.reset));
  }

  if (!minLength && showClear) {
    buttons.push( /*#__PURE__*/React.createElement(Button, {
      key: "clear",
      link: true,
      "data-event-name": "clear",
      onClick: function onClick() {
        update([]);
        onClear([]);
        trackEvent({
          componentName: trackComponentName,
          eventName: 'clear'
        });
      }
    }, getLocale(locale).common.clear));
  }

  return /*#__PURE__*/React.createElement(Form, _extends({
    id: id,
    size: size,
    bordered: bordered,
    className: classNames('jmtd-checkbox-group', className),
    alignControlWidth: alignControlWidth,
    separator: separator,
    gutter: 0,
    labelAlign: withLabel && showAll || withMore ? 'left' : 'right'
  }, formProps), buttons.length ? /*#__PURE__*/React.createElement(ConfigConsumer, {
    context: FormContext
  }, function (_ref9) {
    var configBordered = _ref9.bordered;
    return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref10) {
      var configSize = _ref10.size;
      return /*#__PURE__*/React.createElement("div", {
        "data-component-name": componentName,
        className: classNames('jmtd-checkbox-group-wrapper', {
          'jmtd-checkbox-group-bordered': configBordered,
          'jmtd-checkbox-group-large': configSize === 'large',
          'jmtd-checkbox-group-small': configSize === 'small',
          'jmtd-checkbox-group-mini': configSize === 'mini'
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('jmtd-checkbox-group-operations', {
          'jmtd-checkbox-group-custom-search-render': !!searchRender
        })
      }, searchRender, /*#__PURE__*/React.createElement(ButtonGroup, {
        className: "jmtd-checkbox-group-buttons",
        size: ['small', 'mini'].includes(configSize) ? 'small' : 'middle'
      }, buttons)), /*#__PURE__*/React.createElement("div", {
        className: "jmtd-checkbox-group-items"
      }, inner));
    });
  }) : inner);
}